module.exports = __webpack_public_path__ + "img/Feature.c443d604.png";